import { useCallback } from 'react';
import cl from 'classnames';

import { Checkbox } from '../../../../../../../../../helpers/Checkbox';

interface ThreeDStockProductsFiltersAiBrandsFilterItemBrand {
  id: string;
  name: string;
}

interface ThreeDStockProductsFiltersAiBrandsFilterItemProps {
  brand: ThreeDStockProductsFiltersAiBrandsFilterItemBrand;
  onCheckedBrand: (brandId: string, checked: boolean) => void;
  checked: boolean;
  isCompact?: boolean;
}

function ThreeDStockProductsFiltersAiBrandsFilterItem({
  onCheckedBrand,
  brand,
  checked,
  isCompact
}: ThreeDStockProductsFiltersAiBrandsFilterItemProps) {
  const handleCheck = useCallback(
    (checked: boolean) => {
      onCheckedBrand(brand.id, checked);
    },
    [onCheckedBrand, brand]
  );

  return (
    <li className={isCompact ? 'py-0.5' : 'py-1'}>
      <Checkbox
        dataGa={`brand-${brand.name}`}
        checkboxWrapperClassName="flex items-center"
        checkboxClassName={isCompact ? 'basic-checkbox h-3.5 w-3.5' : undefined}
        labelClassName={cl(
          'ml-2 block text-gray-900 dark:text-gray-100 truncate',
          isCompact ? 'text-xs' : 'text-sm'
        )}
        label={brand.name}
        checked={checked}
        onChange={handleCheck}
      />
    </li>
  );
}

export default ThreeDStockProductsFiltersAiBrandsFilterItem;
